module.exports = __webpack_public_path__ + "img/10.35108ae2.jpeg";